var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.465 11.936a4 4 0 003.594-3.298L13.506.333l1.443 8.282a4 4 0 003.623 3.3l8.761.7-8.76.697a4 4 0 00-3.624 3.301l-1.443 8.282-1.447-8.305a4 4 0 00-3.594-3.298l-7.798-.678 7.798-.678zM17.932 23.023a4 4 0 003.577-3.341l.294-1.805.29 1.78a4 4 0 003.607 3.344l1.633.14-1.633.139a4 4 0 00-3.608 3.343l-.29 1.78-.293-1.804a4 4 0 00-3.577-3.34l-1.265-.119 1.265-.117zM13.111 31.035a2.821 2.821 0 002.523-2.356l.045-.275.013.08a3.051 3.051 0 002.752 2.551 3.052 3.052 0 00-2.752 2.55l-.013.082-.045-.276a2.821 2.821 0 00-2.523-2.356z",
    fill: "#D3D2D9"
  })));
}
export default SvgEmptyStateNotifications;